var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SGPGraficoComponent',_vm._b({attrs:{"tipoGrafico":"bar","opcoesGrafico":_vm.chartOptions,"series":_vm.dados},on:{"sgpGraficoEmit":_vm.emissorDados}},'SGPGraficoComponent',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }